import { Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import { AdminRoutes } from "./AdminRoutes";
import { WorkplaceRoutes } from "./WorkplaceRoutes";
import { WorkerRoutes } from "./WorkerRoutes";

export interface AllRoutesProps {
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  renderStartPage: () => JSX.Element | null;
}

export function AllRoutes(props: AllRoutesProps) {
  const { isAdmin, isWorker, isWorkplace, renderStartPage } = props;

  return (
    <Suspense fallback={<></>}>
      <Switch>
        <Route exact path="/" render={renderStartPage} />

        <Route exact path="/enter" render={renderStartPage} />

        {isWorkplace && <WorkplaceRoutes />}

        {isWorker && <WorkerRoutes />}

        {isAdmin && <AdminRoutes />}
      </Switch>
    </Suspense>
  );
}
